// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hQgu","newExpiryDate":"styles_newExpiryDate__218q5","footer":"styles_footer__3hkBw"};